import { useEffect } from 'react';
import { Question } from '../../../types';
import { DecimalPlacesSelector, TagsField } from '../../components';

interface DecimalQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function DecimalQuestionConfig({ question, onEdit }: DecimalQuestionConfigProps) {
  useEffect(() => {
    if (question.decimalPlaces === undefined || question.decimalPlaces === null) {
      onEdit(question.id, { decimalPlaces: 2 });
    }
  }, []);

  return (
    <div className="grid gap-4">
      <DecimalPlacesSelector
        value={question.decimalPlaces || 2}
        onChange={(value) => onEdit(question.id, { decimalPlaces: value })}
      />
      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
